// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__1ocxj","link":"Pagination_link__7O43V","disabled":"Pagination_disabled__3dUns"};